/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiserviceMelcoFusionModelsFusionAppSetting
 */
export interface ApiserviceMelcoFusionModelsFusionAppSetting {
    /**
     * 
     * @type {string}
     * @memberof ApiserviceMelcoFusionModelsFusionAppSetting
     */
    measurement_unit: string;
    /**
     * 
     * @type {string}
     * @memberof ApiserviceMelcoFusionModelsFusionAppSetting
     */
    default_embroidery_production_file_format: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiserviceMelcoFusionModelsFusionAppSetting
     */
    enable_production_links: boolean;
}

export function ApiserviceMelcoFusionModelsFusionAppSettingFromJSON(json: any): ApiserviceMelcoFusionModelsFusionAppSetting {
    return ApiserviceMelcoFusionModelsFusionAppSettingFromJSONTyped(json, false);
}

export function ApiserviceMelcoFusionModelsFusionAppSettingFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiserviceMelcoFusionModelsFusionAppSetting {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'measurement_unit': json['measurement_unit'],
        'default_embroidery_production_file_format': json['default_embroidery_production_file_format'],
        'enable_production_links': json['enable_production_links'],
    };
}

export function ApiserviceMelcoFusionModelsFusionAppSettingToJSON(value?: ApiserviceMelcoFusionModelsFusionAppSetting | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'measurement_unit': value.measurement_unit,
        'default_embroidery_production_file_format': value.default_embroidery_production_file_format,
        'enable_production_links': value.enable_production_links,
    };
}


